import { mainAdminSplitApi } from 'redux/store/mainSplitApi'
import { RASN_CHANNELS } from 'types/Instruction'
import { RasnChannel } from 'types/RASN'

interface ChannelsConfigResponse {
  channels: RasnChannel[]
}

/**
 * Per-deployment channel allow-list. Windrunner overrides to {DIGITAL,
 * NON_DIGITAL} so SI filter dropdowns there don't expose RETAIL/WHOLESALE,
 * which Windrunner consolidates under NON_DIGITAL.
 *
 * Fallback: if the backend hasn't shipped this endpoint yet (older
 * unit-handling-service) or the call fails, we return the full enum so the
 * UI keeps working as before — never block supervisors on a config 404.
 */
const configApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAvailableChannels: builder.query<RasnChannel[], void>({
      query: () => '/config/channels',
      transformResponse: (response: ChannelsConfigResponse) => {
        const list = Array.isArray(response?.channels) ? response.channels : []
        const valid = list.filter((ch): ch is RasnChannel =>
          (RASN_CHANNELS as readonly string[]).includes(ch)
        )
        return valid.length > 0 ? valid : [...RASN_CHANNELS]
      },
      keepUnusedDataFor: 3600
    })
  })
})

export const { useFetchAvailableChannelsQuery } = configApi
